import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Helmet } from 'react-helmet'
import { Tabs, Tab, Button, Table, Checkbox } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import ModalButton from '../utils/modalButton'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import EmbededEntityInput from '../input/embedded_entity'
import ExpensesEdit from './parts/expenses'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import PaymentsEdit from './parts/payments'
import SelectInput from '../input/select'
import SharesEdit from './parts/shares'
import TextArea from '../input/textArea'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { observable } from 'mobx'
import HelpOverlay from '../utils/helpOverlay'
import orderBy from 'lodash/orderBy'

const ContractEditForm = observer(({ store, disabled, selectionState }) => {
  const entity = store.cv.record
  const errors = store.cv.errors
  const updateField = store.cv.updateData.bind(store.cv)
  const selectionStateLength = selectionState && selectionState.get() && selectionState.get().length
  const handleActive = tab => {
    store.selectedTab = tab
  }
  const costsTotal = (store.cv.record.has('costs_total') && store.cv.record.get('costs_total')
    ? [...store.cv.record.get('costs_total')]
    : [])
    .sort((a, b) => ('' + a.platform).localeCompare('' + b.platform) || ('' + a.expense_type).localeCompare('' + b.expense_type))
  const sumTotal = entity && store.cv.record.get('contract_mgs') &&
    store.cv.record.get('contract_mgs').reduce((total, i) => total + parseFloat(i.mg_value), 0)
  const showFReports = store.cv.record.has('financial_reports') && store.cv.record.get('financial_reports') &&
    store.cv.record.get('financial_reports').length

  const recordID = store.cv.record.has('id') && store.cv.record.get('id') ? parseInt(store.cv.record.get('id')) : null
  const parentFilter = recordID ? i => i.id === recordID || i.parent_id > 0 : undefined
  const isParent = store.cv.record.has('parent_id') && store.cv.record.get('parent_id') && store.cv.record.get('parent_id') > 0

  const contractPayments = (store.cv.record.has('contract_payments') && store.cv.record.get('contract_payments')) || []
  const skipStatus = ['postponed', 'canceled']

  const constantsAbsRec = store.options.has('constantsList') &&
    store.options.get('constantsList') &&
    store.options.get('constantsList').find(i => i.id === 'PAYMENTS_ROUNDING_NO_WARNING')
  const constantsAbsVal = constantsAbsRec && constantsAbsRec.List_code ? parseFloat(constantsAbsRec.List_code) : 0

  // const totalRevenues = contractPayments.reduce((total, i) => total + parseFloat(i.amount_to_be_paid || 0), 0)
  let totalPayments = 0
  let totalPaymentsWithVat = 0
  let totalRevenues = 0
  let totalPaymentsCalculated = 0
  let totalWireFee = 0
  let totalWithholdingTax = 0
  let totalInProcessingToPaid = 0
  let totalInProcessingTotal = 0

  contractPayments.filter(i => !skipStatus.includes(i.status)).map(i => {
    totalPayments += parseFloat(i.amount_paid || 0)
    totalPaymentsWithVat += parseFloat(i.amount_paid_including_vat || 0)
    totalRevenues += parseFloat(i.amount_to_be_paid || 0)
    if (i.amount_paid !== undefined && i.amount_paid !== null &&
      i.amount_paid !== '' && i.amount_paid.toString().length > 0) {
      totalPaymentsCalculated += parseFloat(i.amount_paid || 0)
      totalWireFee += parseFloat(i.wire_fee || 0)
      totalWithholdingTax += parseFloat(i.withholding_tax_amount || 0)
    }
    if (i.status && (i.status === 'new' || i.status === 'in_processing')) {
      totalInProcessingToPaid += parseFloat(i.amount_to_be_paid || 0)
      totalInProcessingTotal += parseFloat(i.amount_paid || 0) + parseFloat(i.wire_fee || 0) + parseFloat(i.withholding_tax_amount || 0)
    }
  })

  const lastPaymentSorted = orderBy(contractPayments, ['year', 'month', 'id'], ['desc', 'desc', 'desc'])
  const lastPayment = lastPaymentSorted && lastPaymentSorted.length > 0
    ? lastPaymentSorted.shift()
    : null
  const lastPaymentAmount = lastPayment && lastPayment.amount_to_be_paid
    ? parseFloat(lastPayment.amount_to_be_paid)
    : 0
  const lastPaymentCalculated = lastPayment
    ? parseFloat(lastPayment.amount_paid || 0) + parseFloat(lastPayment.wire_fee || 0) + parseFloat(lastPayment.withholding_tax_amount || 0)
    : 0
  const amountCalculatedDifference = parseFloat(lastPaymentAmount - lastPaymentCalculated).toFixed(2)
  totalRevenues = lastPaymentAmount

  const totalRevenuesCalculatedBool = parseFloat(totalPaymentsCalculated + totalWireFee + totalWithholdingTax).toFixed(2) !== parseFloat(totalRevenues).toFixed(2)
  const totalRevenuesInProcessingBool = parseFloat(totalInProcessingToPaid).toFixed(2) !== parseFloat(totalInProcessingTotal).toFixed(2)
  const totalPaymentsWithTaxes = parseFloat(totalPayments + totalWireFee + totalWithholdingTax)
  const statusToHideBool = contractPayments.find(i => ['postponed', 'canceled'].includes(i.status))
  const lastPaymentDifference = parseFloat(totalPaymentsWithTaxes + lastPaymentAmount - lastPaymentCalculated)

  const common = (
    <div className='row'>
      <div className='col-xs-12 col-sm-12 col-md-6'>
        <p style={{ paddingBottom: '0.25em' }}>
          <h5 className='card-title'>{store.__('Basic settings ')}</h5>
        </p>
        <TextInput label={store.__('name')} attr={'name'} record={entity}
          onChange={updateField} errors={errors} disabled={disabled} />
        <SelectInput
          label={store.__('parent')}
          attr={'parent_id'}
          record={entity}
          labelattr={(opt, idx) => {
            return `${opt.name} (${opt.contract_type || '----'})`
          }}
          onChange={updateField}
          optionsattr={'contracts'}
          optionsrecord={store.options}
          valueattr='id'
          valueFilterFc={parentFilter}
          errors={errors} disabled={disabled} />
        <SelectInput
          label={store.__('contract type')}
          attr={'contract_type'}
          record={entity}
          labelattr='text'
          valueattr='value'
          onChange={updateField}
          optionsrecord={store.options}
          optionsattr={'ContractTypes'}
          errors={errors} disabled={disabled} />
        <DateInput label={store.__('begin date')} attr={'contract_date'} record={entity}
          onChange={updateField} errors={errors} disabled={disabled} />
        <DateInput label={store.__('end date')} attr={'contract_end_date'} record={entity}
          onChange={updateField} errors={errors} disabled={disabled} />
        <TextInput
          label={store.__('license period months')}
          attr={'license_period_months'}
          record={entity}
          onChange={updateField} disabled={disabled} />
        <TextInput
          type='number'
          min='0'
          label={store.__('license period months additional')}
          attr={'autorenewal_license_period_months'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled} />
        <BoolInput label={store.__('autorenewal')} attr={'autorenewal_flg'} record={entity}
          onChange={updateField} disabled={disabled} />
      </div>

      <div className='col-xs-12 col-sm-12 col-md-6'>
        <p style={{ paddingBottom: '0.25em' }}>
          <h5 className='card-title'>{store.__('Financial settings ')}</h5>
        </p>
        <SelectInput
          label={store.__('currency')}
          attr={'currency'}
          record={entity}
          labelattr='text'
          valueattr='value'
          onChange={updateField}
          optionsrecord={store.options}
          optionsattr={'ContractCurrency'}
          errors={errors} disabled={disabled || isParent} />
        <TextInput
          type='number'
          min='0'
          step='.01'
          label={store.__('minimum payment limit')}
          attr={'payment_minimum_limit'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
        <TextInput
          type='number'
          step='.01'
          min='0'
          label={store.__('wire transfer fee')}
          attr={'payment_wire_fee'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
        <TextInput
          label={store.__('IBAN bank number')}
          attr={'payment_iban'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
        <TextInput
          label={store.__('SWIFT/BIC code')}
          attr={'payment_swift'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
        <TextInput
          label={store.__('Bank account number')}
          attr={'payment_account_number'}
          record={entity}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
        <TextArea
          label={store.__('Account detail')}
          attr={'payment_account_detail'}
          record={entity} rows={3}
          onChange={updateField}
          errors={errors} disabled={disabled || isParent} />
      </div>
    </div>
  )

  return (
    <Tabs id='contract_tabs' onSelect={handleActive}
      defaultActiveKey={(store.cv.record.has('id') && store.selectedTab && !isParent
        ? store.selectedTab
        : 1) || 1}>

      <Tab eventKey={1} title={
        <div>
          {store.__('Settings')}
          <HelpOverlay store={store} path='contracts/settings' />
        </div>}>
        {common}
      </Tab>

      <Tab eventKey={2} title={
        <div>
          {store.__('Shares')}
          <HelpOverlay store={store} path='contracts/shares' />
        </div>
      }>
        <div className='row'>
          <div className='col-xs-12 col-md-6'>
            <SharesEdit store={store} disabled={disabled} />
          </div>
          <div className='col-xs-12 col-md-6'>
            <BoolInput
              label={store.__('proportional shares')}
              attr={'shares_proportional_flg'}
              record={entity}
              onChange={updateField} disabled={disabled} />
            <TextInput
              componentClass='textarea' rows='6'
              label={store.__('rules for revenue sharing')}
              attr={'rules_for_revenue_sharing'}
              record={entity} onChange={updateField}
              errors={errors} disabled={disabled} />
          </div>
        </div>
      </Tab>

      <Tab eventKey={3} title={
        <div>
          {store.__('Contract costs')}
          <HelpOverlay store={store} path='contracts/contract_costs' />
        </div>}>
        <ExpensesEdit
          store={store}
          items={store.cv.record.get('costs')}
          attr={'costs'}
          disabled={disabled} />
      </Tab>

      {!showFReports ? null : <Tab eventKey={4} title={
        <div>
          {store.__('Financial reports')}
          <HelpOverlay store={store} path='contracts/financial_reports' />
        </div>}>
        <button className='btn btn-primary' type='button' disabled={!selectionStateLength}
          onClick={store.downloadFinancialReports.bind(store, { selectionState, customItems: entity.get('financial_reports') })}>
          <span className='glyphicon glyphicon-download' />&nbsp;
          {store.__('Download selected')}
          {selectionStateLength ? ` (${selectionStateLength}x)` : ''}
        </button>
        <EmbededEntityInput disabled disabledRemove
          store={store}
          attr='financial_reports'
          fields={[
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => {
              return <TextField attr={attr} val={row.id} Component={({ text }) => (
                <a href={`${Conf.url}/financial_reports/report/${encodeURIComponent(row.s3path)}?token=${store.authToken}`}
                  target='_blank' rel='noreferrer' title={row.s3path}><span className='glyphicon glyphicon-file' />
                </a>
              )} />
            },
            (attr, row) => {
              const DetailLink = ({ text }) => (
                <a className='item-link-width' title={store.__('Click to open detail')} href='javascript:void(0)'
                  onClick={() => store.goTo('entity_detail', { entityname: 'clients', id: row.client_id })}>
                  <span className='glyphicon glyphicon-share-alt' />&nbsp;
                  {store.options.get('clients').find(i => i.id === row.client_id)
                    ? store.options.get('clients').find(i => i.id === row.client_id).name
                    : null}
                </a>
              )
              return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
            },
            (attr, row) => (<TextField attr={attr} val={row[attr]} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} />)
          ]}
          rowId={(row) => null}
          selectionState={selectionState}
        />
      </Tab>}

      <Tab eventKey={5} title={
        <div>
          {store.__('Contract overview (costs)')}
          <HelpOverlay store={store} path='contracts/contract_overview' />
        </div>}>
        <EmbededEntityInput disabled
          customRowStyleClass={row => {
            if (row.costs_total) {
              return 'contract-overview-custom-row'
            }
          }}
          store={store}
          attr={'costs_total'}
          fields={[
            (attr, row) => (<OptionsField attr={attr} val={row[attr]}
              options={store.options.get('Platforms')}
              labelattr='text' />),
            (attr, row) => (<OptionsField attr={attr} val={row[attr]}
              options={store.options.get('RightsTypes')}
              labelattr='text' valueattr='value' />),
            (attr, row) => (<OptionsField attr={attr} val={row[attr]}
              options={store.options.get('ExpenseTypes')}
              labelattr='text' valueattr='value' />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />),
            (attr, row) => (<TextField attr={attr} val={row[attr]} toFixed={2} />)
          ]}
          rowId={(row) => (row.platform)}
        />
        {costsTotal && costsTotal.length > 0 ? <Table striped bordered condensed>
          <tbody>
            <tr>
              <th>Complete total (sum)</th>
              <th className={'contract-overview-custom-fixed-size'}>{
                <TextField val={costsTotal && costsTotal.reduce((total, i) => total + parseFloat(i.costs_past_due_date), 0)} toFixed={2} />
              }</th>
              <th className={'contract-overview-custom-fixed-size'}>{
                <TextField val={costsTotal && costsTotal.reduce((total, i) => total + parseFloat(i.costs_before_due_date), 0)} toFixed={2} />
              }</th>
              <th className={'contract-overview-custom-fixed-size'}>{
                <TextField val={costsTotal && costsTotal.reduce((total, i) => total + parseFloat(i.costs_total), 0)} toFixed={2} />
              }</th>
              <th className={'contract-overview-custom-fixed-size'} />
            </tr>
          </tbody>
        </Table> : null}
      </Tab>

      {!isParent
        ? <Tab eventKey={'6'} title={
          <div>
            {store.__('Payments')}
            <HelpOverlay store={store} path='contracts/contract_payments' />
          </div>}>
          <div className='contract-payment-overview'>

            {totalRevenuesCalculatedBool && totalPayments > 0 && !store.historicDataFilterActive && totalRevenuesInProcessingBool
              ? <div className='alert alert-warning'>
                <p><strong>{store.__('Warning')}:</strong> &nbsp;
                  {store.__('Please process the "New" or "In processing" records.')}
                </p>
              </div>
              : null}

            {amountCalculatedDifference && amountCalculatedDifference !== (0).toFixed(2) && !store.historicDataFilterActive
              ? <div className='alert alert-warning'>
                <p><strong>{store.__('Warning')}:</strong> &nbsp;
                  {amountCalculatedDifference < 0
                    ? store.__('The "Transfer amount" is overpaid. The different amount is: ') +
                    parseFloat(amountCalculatedDifference).toFixed(2)
                    : store.__('The "Transfer amount" is not paid in full. The different amount is: ') +
                    Math.abs(parseFloat(amountCalculatedDifference)).toFixed(2)
                  }</p>
              </div>
              : null}

            {statusToHideBool
              ? <div className='well well-sm'
                style={{ width: 'auto', display: 'inline-block', marginBottom: '-2.5em' }}>&nbsp;
                <Checkbox inline
                  className={store.additionalDataFilterActive ? 'text-success' : ''}
                  checked={store.additionalDataFilterActive}
                  onChange={() => { store.additionalDataFilterActive = !store.additionalDataFilterActive }}>
                  {store.__('Hide postponed and canceled records')} &nbsp;
                </Checkbox>
              </div>
              : null}

            <PaymentsEdit
              customRowStyleClass={row => {
                if (row.costs_total) {
                  return 'contract-payment-overview'
                }
              }}
              attr={'contract_payments'}
              disabled={disabled}
              items={store.cv.record.get('contract_payments')}
              store={store} />
          </div>

          {(totalRevenues > 0 || totalPaymentsWithVat > 0 || totalPayments > 0) && !store.historicDataFilterActive
            ? <Table striped bordered condensed className='contract-payment-overview'>
              <tbody>
                <tr>
                  <th>{store.__('Total')}:</th>
                  <th /><th /><th /><th /><th />
                  <th />
                  <th title={store.__('Amount payable calculated')}>
                    <span className={amountCalculatedDifference !== (0).toFixed(2) ? 'text-warning' : ''}>
                      {totalPayments > 0
                        ? parseFloat(totalPaymentsWithTaxes || 0).toFixed(2)
                        : (0).toFixed(2)}
                    </span>
                  </th>
                  <th /><th /><th />
                  <th title={store.__('Transfer amount')}>
                    <span>{totalPayments > 0
                      ? totalPayments.toFixed(2)
                      : (0).toFixed(2)}
                    </span>
                  </th>
                  <th title={store.__('Transfer amount (incl. VAT)')}>
                    {<span>{totalPaymentsWithVat > 0
                      ? totalPaymentsWithVat.toFixed(2)
                      : (0).toFixed(2)}
                    </span>}
                  </th>
                  <th /><th /><th />
                </tr>
              </tbody>
            </Table>
            : null}

          {(totalRevenues > 0 || totalPaymentsWithVat > 0 || totalPayments > 0) && !store.historicDataFilterActive
            ? <Table striped bordered condensed className='contract-payment-overview'>
              <tbody>
                <tr>
                  <th colSpan='2' className='contract-payment-colspan2'>{store.__('Amout payable total')}:</th>
                  <th /><th /><th /><th />
                  <th />
                  <th title={store.__('Amout payable total')}> {lastPaymentDifference
                    ? parseFloat(lastPaymentDifference || 0).toFixed(2)
                    : (0).toFixed(2)}
                  </th>
                  <th title={store.__('Differece between "Amount payable calculated" and "Amout payable total"')}>
                    {store.__('Difference')}:
                  </th>
                  <th title={store.__('Differece between "Amount payable calculated" and "Amout payable total"')}>
                    <span className={amountCalculatedDifference !== (0).toFixed(2) ? 'text-warning' : 'text-muted'}>
                      {parseFloat(amountCalculatedDifference || 0).toFixed(2)}
                    </span>
                  </th>
                  <th />
                  <th />
                  <th />
                  <th /><th /><th />
                </tr>
              </tbody>
            </Table>
            : null}
        </Tab>
        : null}
    </Tabs>

  )
})
ContractEditForm.propTypes = {
  store: PropTypes.object.isRequired
}

const ContractEditView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.CONTRACTS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const disabled = !store.hasRight(defaultConst.ENTNAMES.CONTRACTS, 'w')
  const itemId = store.cv.record.has('id') && store.cv.record.get('id')
  const contractItemsButton = store.hasRight(defaultConst.ENTNAMES.CONTRACTITEMS) &&
    <div key='1' className='buttons-vertical-align' style={{ display: 'inline-block' }}>
      <HelpOverlay helpContent='Show titles/contractitems associated with this contract'><Button
        disabled={!itemId} title={!itemId ? store.__('Requires save before adding contract item') : ''}
        bsStyle='info' onClick={() => {
          const id = store.cv.record.get('id')
          return store.goTo('contractitems', { entname: 'contract', id })
        }}>
        <span className='glyphicon glyphicon-share-alt' />&nbsp;{store.__(linkConst.LINK_CONTRACT_ITEMS_TITLE)}
      </Button></HelpOverlay>
    </div>

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.CONTRACTS, 'w')}
      options={{
        customActionButtons: [
          contractItemsButton,
          (itemId && <ModalButton key='2' store={store} modal={store.modalEntity} title={store.cv.record.get('name')} />)
        ]
      }}>
      <ContractEditForm store={store} disabled={disabled} selectionState={observable.box([])} />
      <Helmet title={store.__(linkConst.LINK_CONTRACTS_TITLE).concat(defaultConst.HTML_DIVIDER) + (store.cv.record.get('id')
        ? (store.cv.record && store.cv.record.has('name')
          ? store.cv.record.get('name')
          : store.__(defaultConst.TITLE_EDIT))
        : store.__(defaultConst.TITLE_CREATE))} />
    </EditView>
  )
}
export default observer(ContractEditView)
